import { Card, Radio } from 'antd';
import React, { Component } from 'react';
import './Styles/DependentCardComponent.scss';
import Icons from 'Common/Icons';

export class DependentCardComponent extends Component {
    constructor(props){
        super(props);
        this.state={

        };
    }
  render() {
    return (
    <div >
        <Radio.Button className={`signup-dependent-card ${this.props.index+1 == this.props.selectedKey ? "signup-dependent-selected-card" : ""} `} value={this.props.index}>
            <img  src={this.props.index+1 == this.props.selectedKey ? Icons.circle_checked : Icons.circle_unchecked}/>
            <div className='dependent-title vertical-spacing'>{this.props.title}</div>
            <div className='dependent-sub-title'>{this.props.subTitle}</div>
        </Radio.Button>
    </div>
    )
  }
}

export default DependentCardComponent;